import jQuery from 'jquery';
let $ = jQuery;

// define EVENTs
import "HSNDIR/AccountNavigation/Cabinet.js";
import "HSNDIR/Flyout.js";

/**
    * class HSN.ArcadePopupCoordinator
    *
    * Encapsulates the common functionality of the ArcadePopupCoordinator.
    **/
HSN.ArcadePopupCoordinator = function () {
    var application;
    var isFlyoutOpen;
    var isCabinetDrawerOpen;
    var modalOpenCount;

    function reportPopupState() {
        if (!isFlyoutOpen && !isCabinetDrawerOpen && modalOpenCount === 0) {
            application.Events.Trigger(HSN.ArcadePopupCoordinator.EVENT.POPUP_STATE_CLOSED);
        }
        else {
            application.Events.Trigger(HSN.ArcadePopupCoordinator.EVENT.POPUP_STATE_OPEN);
        }
    }

    function init(config) {
        application = config.application;
        isFlyoutOpen = false;
        isCabinetDrawerOpen = false;
        modalOpenCount = 0;

        /*application.Events.On(HSN.Modal.EVENT.MODAL_OPEN, function () {
            modalOpenCount = modalOpenCount + 1;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.Modal.EVENT.MODAL_CLOSE, function () {
            modalOpenCount = (modalOpenCount - 1 < 0) ? 0 : modalOpenCount - 1;
            reportPopupState();
            return;
        });*/
        application.Events.On(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, function () {
            isCabinetDrawerOpen = true;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.AccountNavigation.Cabinet.EVENT.AFTER_CLOSE, function () {
            isCabinetDrawerOpen = false;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.Flyout.EVENT.BEFORE_OPEN, function () {
            isFlyoutOpen = true;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.Flyout.EVENT.BEFORE_CLOSE, function () {
            isFlyoutOpen = false;
            reportPopupState();
            return;
        });
    }

    return {
        init: init,
        checkPopupState: reportPopupState
    }
};

HSN.ArcadePopupCoordinator.EVENT = {
    POPUP_STATE_OPEN: 'HSN.PopupCoordinator.EVENT.POPUPS_OPEN',
    POPUP_STATE_CLOSED: 'HSN.PopupCoordinator.EVENT.POPUPS_CLOSED'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Arcade/ArcadePopupCoordinator.js